import { vedaonlineAPI } from './api';

const sortNewestFirst = (items) =>
  [...items].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

const normalizeComment = (row) => ({
  id: row?.id != null ? String(row.id) : '',
  username: row?.username ?? row?.user_name ?? '',
  message: row?.message ?? row?.comment_text ?? '',
  date: row?.date ?? row?.created_on ?? null,
});

/**
 * Fetch comments for a saved view by VedaOnline view_id.
 * @param {string|number} viewId
 * @returns {Promise<Array<{ id: string, username: string, message: string, date: string }>>}
 */
export async function fetchPresenterComments(viewId) {
  if (viewId === undefined || viewId === null || String(viewId).trim() === '') {
    return [];
  }

  const response = await vedaonlineAPI.getViewComments(viewId);
  const rows = Array.isArray(response?.data) ? response.data : [];
  return sortNewestFirst(rows.map(normalizeComment));
}
